// js
import React from 'react';
// css
import '../../styles/components/analytics/AdoptionChartLegend.scss';


const AdoptionChartLegend = () => {
  return (
    <div className='analytics__adoption-chart-legend key'>
      <p><i className='icon icon-use-full' /> Fully in use</p>
      <p><i className='icon icon-use-partial' /> Partially in use</p>
      <p><i className='icon icon-use-should' /> Should be in use, &gt;20% data already indexed</p>
      <p><i className='icon icon-use-could' /> Could be in use (with more indexed data)</p>
    </div>
  );
};

export default AdoptionChartLegend;



// WEBPACK FOOTER //
// ./src/components/analytics/AdoptionChartLegend.js